export default __webpack_public_path__ + "media/4@2x.d936de39.jpg";